export default {
	workStyleButton: "Work Style",
	personalDetailsButton: "About {name}",
	personalDetailsHeading: "About {name}",
	workStyleHeading: "Work style",
};
